
import { ref, computed } from "vue";
import { useStore } from 'vuex';
import { Helper } from "@/utils/Helper";
import { NotificationUtils } from "@/utils/NotificationUtils";
import qrcode from "qrcode-generator";
import { Peer } from "peerjs";
import layoutHomeAutoSignQRModal from "@/layouts/home/components/modals/layoutHomeAutoSignQRModal.vue";

export default{
  name: 'notificationsDisplayAllComponent',
  components: {
    layoutHomeAutoSignQRModal
  },
  setup(){
    const store = useStore();
    const noti = new NotificationUtils();
    // const fetchedNotification = ref([]);
    const displayedNotification = ref([]);
    const qr = ref('');
    const title = ref('');
    const message = ref('');

    const isPeerConnectionMade = ref(false);
    const istxnSigned = ref(false);
    const isDisabledModalConfirmSubmitButton = ref(true);

    const isQRModalOpened = ref(false);
    const closeModal = () => {
      isQRModalOpened.value = false;
    }
    const displayQRModal = async(ttl: string, msg: string, payload: string, notificationId: string) => {
      isQRModalOpened.value = true;
      title.value = ttl;
      message.value = msg;
      const peer = new Peer();
      const secret = "this is a secret";
      const qrCode = qrcode(0, 'H');
      peer.on("open", (id) => {
        let data = {
          // payload: payload,
          payload: id,
          type:'reqPeerID',
          recvId: id,
          secret: secret,
          generationHash: store.getters['config/generationHash'],
          chain: 'off',
          callbackUrl: null
        }
        qrCode.addData(JSON.stringify(data));
        qrCode.make();
        qr.value = qrCode.createSvgTag({scalable: true});
      });

      peer.on("connection", (conn) => {
        conn.on("data", async(data: any) => {
          if(data === 'requestTxnSigning'){
            isPeerConnectionMade.value = true;
            conn.send({
              type: 'txn',
              payload: payload
            });
          }else if(data === 'txnHash'){
            conn.send("success");
            isPeerConnectionMade.value = false;
            istxnSigned.value = true;
            isDisabledModalConfirmSubmitButton.value = false;
          }else{
            await noti.fetchReadNotification('notificationId=' + notificationId);
          }
        });
      });
    }

    // pagination
    const totalAssets = ref(0);
    const pages = ref(20);
    const currentPage = ref(1);
    const totalPages = ref(0);
    const enableNextPage = ref(false);

    // (async() => {
    //   fetchedNotification.value = await noti.fetchAllQRUnreadNotifications(currentPage.value-1, Number(pages.value) + 1);
    //   displayedNotification.value = fetchedNotification.value.pop();
    //   console.log(displayedNotification.value)
    // })()

    // pagination
    let fetchedNotification;
    const loadNotifications = async() => {
      // totalPages.value = Math.ceil(loadedAssets.value.length / pages.value);
      fetchedNotification = await noti.fetchAllQRUnreadNotifications(currentPage.value-1, Number(pages.value) + 1);
      if(fetchedNotification.length > pages.value){
        enableNextPage.value = true;
        displayedNotification.value = fetchedNotification.splice(0, pages.value);
      // console.log(displayedNotification.value)
    }else{
        enableNextPage.value = false;
        displayedNotification.value = fetchedNotification;
      }
    };
    loadNotifications();

    const enableFirstPage = computed(()=> {
      return currentPage.value > 1;
    });

    const enablePreviousPage = computed(() => {
      return currentPage.value > 1;
    });

    const naviFirst = () => {
      currentPage.value = 1;
      loadNotifications();
    };

    const naviPrevious =() => {
      --currentPage.value;
      loadNotifications();
    };

    const naviNext = () => {
      ++currentPage.value;
      loadNotifications();
    };

    const naviLast = () => {
      currentPage.value = totalPages.value;
      loadNotifications();
    };

    const changeRows = () => {
      loadNotifications();
    }

    return {
      qr,
      title,
      message,
      isQRModalOpened,
      closeModal,
      displayQRModal,
      displayedNotification,
      // pagination
      enableFirstPage,
      enablePreviousPage,
      enableNextPage,
      totalAssets,
      pages,
      currentPage,
      totalPages,
      naviFirst,
      naviPrevious,
      naviNext,
      naviLast,
      changeRows,
      Helper,
      isPeerConnectionMade,
      istxnSigned,
      isDisabledModalConfirmSubmitButton,
    }
  }
}
